function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import ButtonBase from "../../legacy/Button/Button";
export function AlertDismissButton(_param) {
    var forwardedRef = _param.forwardedRef, _appearance = _param.appearance, icon = _param.icon, iconAlign = _param.iconAlign, isRtl = _param.isRtl, style = _param.style, text = _param.text, _accessibilityLabel = _param.accessibilityLabel, accessibilityLabel = _accessibilityLabel === void 0 ? 'Dismiss' : _accessibilityLabel, rest = _objectWithoutProperties(_param, [
        "forwardedRef",
        "appearance",
        "icon",
        "iconAlign",
        "isRtl",
        "style",
        "text",
        "accessibilityLabel"
    ]);
    var ref = style || {
        buttonStyle: {},
        iconStyle: {}
    }, buttonStyle = ref.buttonStyle, iconStyle = ref.iconStyle;
    var iconAlignment = function(buttonIcon, buttonIconAlign) {
        var alignment = buttonIconAlign ? buttonIconAlign.toLowerCase() : 'start';
        return {
            iconBefore: buttonIcon && alignment === 'start' ? buttonIcon : undefined,
            iconAfter: buttonIcon && alignment === 'end' ? buttonIcon : undefined
        };
    };
    var ref1 = iconAlignment(icon, iconAlign), iconBefore = ref1.iconBefore, iconAfter = ref1.iconAfter;
    return _jsx(ButtonBase, _objectSpread({}, rest, {
        style: buttonStyle,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        iconStyle: _objectSpread({}, iconStyle, {
            size: 'm'
        }),
        isRtl: isRtl,
        forwardedRef: forwardedRef,
        accessibilityLabel: accessibilityLabel,
        children: text
    }));
}
